export default __webpack_public_path__ + "static/media/seyssins.d534eb44.jpg";